import React from 'react';

import { TYPE_CONVERSION } from 'scenes/Integrations/constants';
import {
  useCreateConversion,
  useUpdateConversion,
  useLoadConversion,
  useIsUpdatingConversion,
} from 'scenes/Integrations/data';

import IntegrationConversionForm from './IntegrationConversionForm';
import { conversionSchema } from './schemas';

const defaultValues = conversionSchema.default();

export const IntegrationConversionFormCreate = ({
  onSubmit,
  onClose,
  onExited,
  open,
  providerType,
}) => {
  const [create] = useCreateConversion();
  const isUpdating = useIsUpdatingConversion();

  const handleSubmit = async (values) => {
    const response = await create(values);
    onSubmit({ typeId: TYPE_CONVERSION, id: response });
  };

  const initialValues = {
    providerTypeId: providerType?.id,
    ...defaultValues,
  };

  return (
    <IntegrationConversionForm
      title={`Add ${providerType?.name} Integration`}
      loading={isUpdating}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export const IntegrationConversionFormEdit = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data, isLoading } = useLoadConversion(id);
  const [update, { isLoading: isUpdating }] = useUpdateConversion();

  const handleSubmit = async (values) => {
    const response = await update(values);
    onSubmit(response);
  };

  const initialValues = data
    ? {
        providerTypeId: data?.providerType?.id,
        ...data,
      }
    : data;

  return (
    <IntegrationConversionForm
      loading={isLoading || isUpdating}
      title={`Edit ${data?.providerType?.name} Integration`}
      subTitle={`#${id}`}
      onClose={onClose}
      active={!!data}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};

export const IntegrationConversionFormDuplicate = ({
  id,
  onSubmit,
  onClose,
  onExited,
  open,
}) => {
  const { data, isLoading } = useLoadConversion(id);
  const [create] = useCreateConversion();
  const isUpdating = useIsUpdatingConversion();

  const handleSubmit = async (values) => {
    const response = await create(values);
    onSubmit({ typeId: TYPE_CONVERSION, id: response });
  };

  const initialValues = data
    ? {
        providerTypeId: data?.providerType?.id,
        ...data,
      }
    : data;

  return (
    <IntegrationConversionForm
      title={`Add ${data?.providerType?.name} Integration`}
      loading={isLoading || isUpdating}
      onClose={onClose}
      active={!!data}
      initialValues={initialValues}
      onSubmit={handleSubmit}
      onExited={onExited}
      open={open}
    />
  );
};
